module.exports = "/365FarmNet/dist/termsAcceptanceDialog.183f0ff5396a03475f34bb7ecd850056.html";